/** @jsx jsx */
import { jsx, Flex, Box } from 'theme-ui'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { Fragment, useState } from 'react'
import chevronRight from '../../../icons/chevronRight.svg'
import chevronLeft from '../../../icons/chevronLeft.svg'
import styled from '@emotion/styled'

const convertNumberToArray = num => {
  let arr = []
  while (arr.length < num) {
    arr.push(arr.length + 1)
  }
  return arr
}

const Logo = styled.img`
  width: 12px;
`

const Pagination = ({
  next,
  prev,
  jump,
  currentData,
  currentPage,
  maxPage,
}) => {
  const [pageCohortToShow, setPageCohortToShow] = useState(3)
  const pages = convertNumberToArray(maxPage)
  const { mobile } = useWindowSize()

  function pageNextSet() {
    if (pages.length + 1 <= pageCohortToShow) {
      return
    }
    setPageCohortToShow(pageCohortToShow + 3)
  }
  function pagePrevSet() {
    if (pageCohortToShow === 3) {
      return
    }
    setPageCohortToShow(pageCohortToShow - 3)
  }

  function isInCohort(pageNumber) {
    const min = pageCohortToShow - 3

    return pageNumber <= pageCohortToShow && pageNumber > min
  }

  return (
    <Flex sx={{ justifyContent: 'center', p: 20 }}>
      <Flex
        sx={{
          width: 70,
          height: 70,
          m: 10,
          textAlign: 'center',
          justifyContent: 'center',
          bg: 'white',
          color: 'text',
          alignItems: 'center',
          border: 'default',
          cursor: 'pointer',
        }}
        disabled={(mobile || pages.length > 5) && pageCohortToShow === 3}
        onClick={() => (mobile || pages.length > 5 ? pagePrevSet() : prev())}
      >
        <Logo src={chevronLeft} />
      </Flex>
      {pages.map((p, k) => {
        if ((mobile || pages.length > 5) && !isInCohort(k + 1)) {
          return <Fragment />
        }
        return (
          <Flex
            sx={{
              width: 70,
              height: 70,
              m: 10,
              textAlign: 'center',
              justifyContent: 'center',
              bg: currentPage - 1 === k ? 'black' : 'white',
              color: currentPage - 1 === k ? 'white' : 'text',
              alignItems: 'center',
              border: 'default',
              cursor: 'pointer',
            }}
            onClick={() => jump(k + 1)}
          >
            {k + 1}
          </Flex>
        )
      })}
      <Flex
        sx={{
          width: 70,
          height: 70,
          m: 10,
          textAlign: 'center',
          justifyContent: 'center',
          bg: 'white',
          color: 'text',
          alignItems: 'center',
          border: 'default',
          cursor: 'pointer',
        }}
        disabled={
          (mobile || pages.length > 5) && pages.length + 1 <= pageCohortToShow
        }
        onClick={() => (mobile || pages.length > 5 ? pageNextSet() : next())}
      >
        <Logo src={chevronRight} />
      </Flex>
    </Flex>
  )
}

export default Pagination
